import { trpc } from '@/lib/trpc';

const useLogin = () => {
	const utils = trpc.useUtils();

	const { mutate, isPending, error } = trpc.user.login.useMutation({
		onSuccess: (response) => {
			if (!response.user) return;
			utils.user.get.setData(undefined, () => {
				return { status: 200, user: response.user };
			});
			utils.user.get.invalidate();
		},
	});

	return {
		login: mutate,
		loginLoading: isPending,
		loginError: error,
	};
};

export default useLogin;
